import { createActions } from 'redux-actions';

export const {
  toggleAside,
  toggleSourceInput,
  toggleCategoriesInput,
  toggleCameraInput,
  toggleBatchInput,
  toggleImageSnInput,
  toggleInfraredModeInput,
  toggleImageSizeInput,
  toggleImageTimeInput,
  switchGridImageSize,
  switchListFontSize,
  switchImageSizeSearchMode,
  gridScrollPositionChange,
  updateGridScrollPosition,
  setScrollContainer
} = createActions({
  TOGGLE_ASIDE: () => undefined,
  TOGGLE_SOURCE_INPUT: () => undefined,
  TOGGLE_CATEGORIES_INPUT: () => undefined,
  TOGGLE_CAMERA_INPUT: () => undefined,
  TOGGLE_BATCH_INPUT: () => undefined,
  TOGGLE_IMAGE_SN_INPUT: () => undefined,
  TOGGLE_IMAGE_SIZE_INPUT: () => undefined,
  TOGGLE_INFRARED_MODE_INPUT: () => undefined,
  TOGGLE_IMAGE_TIME_INPUT: () => undefined,
  SWITCH_GRID_IMAGE_SIZE: mode => mode,
  SWITCH_LIST_FONT_SIZE: mode => mode,
  SWITCH_IMAGE_SIZE_SEARCH_MODE: mode => mode,
  GRID_SCROLL_POSITION_CHANGE: ({ scrollTop, scrollHeight, offsetHeight }) => ({
    scrollTop,
    scrollHeight,
    offsetHeight
  }),
  UPDATE_GRID_SCROLL_POSITION: position => position,
  SET_SCROLL_CONTAINER: el => el
});



// WEBPACK FOOTER //
// ./src/actions/UIActions.js